module.exports = __webpack_public_path__ + "img/lantmateriet.c207ec49.jpg";